import * as React from 'react';
import TimerService from './TimerService';
import {formatTimeDiff} from '../StopTimerDialog/TimerUtils';

const RunningTime = ({startTime}: {startTime: Date}): JSX.Element => {
  const timerService = TimerService.getInstance(startTime);

  const [duration, setDuration] = React.useState(
    timerService.getCurrentTimerValue()
  );

  React.useEffect(() => {
    const subscription = timerService.timerValue$.subscribe(value => {
      setDuration(value);
    });
    timerService.subscribe();
    return () => {
      subscription.unsubscribe();
      timerService.unsubscribe();
    };
  }, [timerService]);

  return <p>{formatTimeDiff(duration)}</p>;
};

export default RunningTime;
